import { useState } from 'react';
import language from '../../variables/language';

// Controlled tags editor: `tags` is a plain array of name strings, `onChange`
// receives the full next array. Caller decides when/how to persist it (create
// forms buffer it until submit, edit views can PUT on every change).
// `placeholder`/`emptyLabel` default to the original client-tags copy so the
// two existing callers (FormClient/ClientCreateModal) need no changes.
export default function TagsEditor({ tags, onChange, placeholder, emptyLabel }) {
   const [input, setInput] = useState('');
   const lang = language[language.lang].clientsPage;
   const resolvedPlaceholder = placeholder || lang.tagsPlaceholder;
   const resolvedEmptyLabel = emptyLabel || lang.noTags;

   const addTag = () => {
      const trimmed = input.trim();
      if(!trimmed || tags.includes(trimmed)) {
         setInput('');
         return;
      }
      onChange([...tags, trimmed]);
      setInput('');
   }

   const removeTag = (name) => onChange(tags.filter(t => t !== name));

   const handleKeyDown = (e) => {
      if(e.key === 'Enter' || e.key === ',') {
         e.preventDefault();
         addTag();
      }
   }

   return (
      <div className='tags-editor'>
         <div className='tags-editor-chips'>
            {tags.map(name => (
               <span className='tags-editor-chip' key={name}>
                  {name}
                  <span className='tags-editor-chip-remove' onClick={() => removeTag(name)}>×</span>
               </span>
            ))}
            {tags.length === 0 ? <span className='tags-editor-empty'>{resolvedEmptyLabel}</span> : ''}
         </div>
         <div className='tags-editor-input-row'>
            <input className='tags-editor-input' value={input}
               placeholder={resolvedPlaceholder}
               onChange={(e) => setInput(e.target.value)}
               onKeyDown={handleKeyDown} />
            <div className='tags-editor-add-btn' onClick={addTag}>+</div>
         </div>
      </div>
   )
}
